<div class="CameraScanner">
    <div class="flex fx-align-start-center mb-30">
        <h3>{{ "addCount" | translate }}</h3>
    </div>
    <div class="fx-column" fxLayout="column">
        <div class="fx-flex-50 mx-auto">
            <app-quagga-scanner></app-quagga-scanner>
        </div>
        <div class="fx-flex-100 text-center">
            <button color="warning" mat-raised-button>{{ "stop" | translate }}</button>
        </div>
        <div class="fx-flex-100 fx-row fx-align-center">
            <button class="fx-align-simple-center" type="button" color="white" mat-raised-button>{{ "byCategory" | translate }}</button>
            <button class="fx-align-simple-center" type="button" color="white" mat-raised-button>{{ "byArea" | translate }}</button>
            <button class="fx-align-simple-center" type="button" color="white" mat-raised-button>{{ "scanning" | translate }}</button>
        </div>
    </div>
</div>